<svg:g>
  <circle class="duct" cx="50" cy="50" r="46" [ngClass]="{'occupied': duct.occupied}" />

  <g *ngIf="duct.subducts">

    <g [ngSwitch]="duct.subducts.length">
      <g *ngSwitchCase="1">
        <g app-edge-duct-diagram-subduct [cx]="50" [cy]="50" [subduct]="duct.subducts[0]" [i]="1" />
      </g>
      <g *ngSwitchCase="2">
        <g app-edge-duct-diagram-subduct [cx]="30" [cy]="50" [subduct]="duct.subducts[0]" [i]="1" />
        <g app-edge-duct-diagram-subduct [cx]="70" [cy]="50" [subduct]="duct.subducts[1]" [i]="2" />
      </g>
      <g *ngSwitchCase="3">
        <g app-edge-duct-diagram-subduct [cx]="50" [cy]="27" [subduct]="duct.subducts[0]" [i]="1" />
        <g app-edge-duct-diagram-subduct [cx]="30" [cy]="62" [subduct]="duct.subducts[1]" [i]="2" />
        <g app-edge-duct-diagram-subduct [cx]="70" [cy]="62" [subduct]="duct.subducts[2]" [i]="3" />
      </g>
      <g *ngSwitchCase="4">
        <g app-edge-duct-diagram-subduct [cx]="32" [cy]="32" [r]="16" [subduct]="duct.subducts[0]" [i]="1" />
        <g app-edge-duct-diagram-subduct [cx]="68" [cy]="32" [r]="16" [subduct]="duct.subducts[1]" [i]="2" />
        <g app-edge-duct-diagram-subduct [cx]="32" [cy]="68" [r]="16" [subduct]="duct.subducts[2]" [i]="3" />
        <g app-edge-duct-diagram-subduct [cx]="68" [cy]="68" [r]="16" [subduct]="duct.subducts[3]" [i]="4" />
      </g>
      <g *ngSwitchCase="7">
        <g app-edge-duct-diagram-subduct [cx]="36" [cy]="26" [r]="12" [subduct]="duct.subducts[0]" [i]="1" />
        <g app-edge-duct-diagram-subduct [cx]="64" [cy]="26" [r]="12" [subduct]="duct.subducts[1]" [i]="2" />
        <g app-edge-duct-diagram-subduct [cx]="22" [cy]="50" [r]="12" [subduct]="duct.subducts[2]" [i]="3" />
        <g app-edge-duct-diagram-subduct [cx]="50" [cy]="50" [r]="12" [subduct]="duct.subducts[3]" [i]="4" />
        <g app-edge-duct-diagram-subduct [cx]="78" [cy]="50" [r]="12" [subduct]="duct.subducts[4]" [i]="5" />
        <g app-edge-duct-diagram-subduct [cx]="36" [cy]="74" [r]="12" [subduct]="duct.subducts[5]" [i]="6" />
        <g app-edge-duct-diagram-subduct [cx]="64" [cy]="74" [r]="12" [subduct]="duct.subducts[6]" [i]="7" />
      </g>

    </g>

  </g>

</svg:g>
